import { useEffect, useState } from 'react';

const DURATION_SECONDS = 17 * 60 + 34; // 00:17:34
const START = Date.now();

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

/** Shared, synced countdown from 00:17:34 that restarts automatically after reaching 00:00:00. */
export function useCountdown() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = Math.floor((now - START) / 1000);
  const remaining = DURATION_SECONDS - (elapsed % (DURATION_SECONDS + 1));
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) };
}
